import React, { useEffect, useState } from 'react';

const Carousel = ({ items, renderItem, intervalMs = 7000 }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!items || items.length <= 1) {
      return undefined;
    }

    const id = setInterval(() => {
      setIndex((prev) => (prev + 1) % items.length);
    }, intervalMs);

    return () => {
      clearInterval(id);
    };
  }, [items, intervalMs]);

  if (!items || items.length === 0) {
    return null;
  }

  const current = items[index];

  return renderItem(current, index);
};

export default Carousel;
